import { useUserQuery } from 'App/actions/api/user';

const EMPTY_USER = {};

export const useUser = () => {
  return useUserQuery().data ?? EMPTY_USER;
};
